import { useMemo } from "react";
import useGetCurrentUserPermissionScope from "~hooks/useGetCurrentUserPermissionScope.ts";
import type { SeasonTransformed } from "~types/seasonTransformed.ts";

export const useExtractSeasonsFromScope = () => {
  const { data: scopeData } = useGetCurrentUserPermissionScope();

  return useMemo(() => {
    const { scope, resources } = scopeData || {};

    const seasonsData = resources?.seasons || {};
    const competitionsData = resources?.competitions || {};
    const seasons: SeasonTransformed[] = [];
    const leagueTree = scope?.leagueTree || [];

    leagueTree.forEach(({ competitions }) => {
      competitions.forEach(({ seasonIds, competitionId }) => {
        const competitionName = competitionsData[competitionId]?.nameLocal || "";
        seasons.push(...seasonIds.map((seasonId) => ({ ...seasonsData[seasonId], competitionName })));
      });
    });

    return seasons;
  }, [scopeData]);
};
